module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('custom-header'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('my-ikedc')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Dispense")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a60a74dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dispense.vue
// module id = 249
// module chunks = 1